import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './Header.scss'

const Header = ({ settings }) => {
    const date = new Date()
    const dayName = () => {
        switch (date.getDay()) {
            case 0:
                return 'Nedjelja'
            case 1:
                return 'Ponedjeljak'
            case 2:
                return 'Utorak'
            case 3:
                return 'Srijeda'
            case 4:
                return 'Četvrtak'
            case 5:
                return 'Petak'
            case 6:
                return 'Subota'
            default:
                return ''
        }
    }

    const day = date.getDay()

    const month = () => {
        switch (date.getMonth()) {
            case 0:
                return 'siječanj'
            case 1:
                return 'veljača'
            case 2:
                return 'ožujak'
            case 3:
                return 'travanj'
            case 4:
                return 'svibanj'
            case 5:
                return 'lipanj'
            case 6:
                return 'srpanj'
            case 7:
                return 'kolovoz'
            case 8:
                return 'rujan'
            case 9:
                return 'listopad'
            case 10:
                return 'studeni'
            case 11:
                return 'prosinac'
            default:
                return ''
        }
    }

    const year = date.getFullYear()
    const time = `${date.getHours()}:${date.getMinutes()}`
    const formatedDate = `${dayName()}, ${day}. ${month()} ${year} | ${time}`

    return (
        <>
            {!settings && (
                <div className="header gray-text">
                    <img src="/images/logo.png" className="A1-logo" alt="A1" />
                    <span>
                        <img src="/images/search.png" className="trazilica" alt="Tražilica" /> Tražilica
                    </span>
                    <div>{formatedDate}</div>
                </div>
            )}
            {settings && (
                <div className="header gray-text">
                    <Link to="/settings" className="settings-link">
                        Postavke
                    </Link>
                    <div>{formatedDate}</div>
                </div>
            )}
        </>
    )
}

export default Header

Header.propTypes = {
    settings: PropTypes.bool
}

Header.defaultProp = {
    settings: false
}
